import { Link, useLocation } from 'react-router-dom'
import Modal from 'react-bootstrap/Modal';
import Orderhistory from '../../Assetes/Images/order-history.png';
import MyAddress from '../../Assetes/Images/mtAddress-Icon.png';
import MyCards from '../../Assetes/Images/myCards-Icon.png'
import AddFav from '../../Assetes/Images/add-fav-icon.png';
import Couponapply from '../../Assetes/Images/coupon-icon.png'
import NoDeals from '../../Assetes/Images/no-deals-img.svg'
import Button from '@mui/material/Button';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch, connect } from 'react-redux';
import { removeProfileData, removeFavList, logoutUser } from "../../Redux/actions/customer"
import { IMAGE_URL } from '../../Components/client-config';
import Avatar from '../../Assetes/Images/avatar.svg';
import useTrackEvent from '../../hooks/useTrackHook';
import useCurrentLocale from '../../hooks/useLanguage';
import { useTranslation } from 'react-i18next';
import { checkPhone } from '../../lib';




function SattingScreen(props: any) {
  const dispatch = useDispatch();
  const userInfo = useSelector((state: any) => state.customer.userInfo);
  const [addEvent] = useTrackEvent();

  const [show, setShow] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const socialLogin = useSelector((state: any) => state.customer.socialLogin);
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const [phone_number, setPhone_number] = useState("")
  const lang = useCurrentLocale();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  useEffect(() => {
    setShow(false);
  }, [location]);

  const handleClose = () => {
    setShow(false);
  };
  const handleLogin = () => {
    addEvent({ category: "events", events: "Login button" })
    const windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'screenview_login'
    })
  };

  const handleShow = () => setShow(true);


  const handlelogoutClick = () => {
    addEvent({ category: "events", events: "Logout button" })
    props.logoutUser(history);

  };
  useEffect(() => {
    const formattedPhoneNumber = userInfo?.phone_number?.split("-")[1];
    checkPhone(formattedPhoneNumber) ? setPhone_number(userInfo?.phone_number) : setPhone_number("")
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    try {
      const dataUrl = sessionStorage.getItem('profilePreview');
      if (dataUrl) {
        setPreviewUrl(dataUrl);
      } else {
        setPreviewUrl(null);
      }
    } catch (_e) {
      setPreviewUrl(null);
    }
  }, [show]);

  const { t } = useTranslation();

  return (
    <div>
      {!isLogged ? (
        <Link to={`/${lang}/login`}>
          <Button
            onClick={() => handleLogin}
            className="f-w-600 bg-theme font-normal setting-logon-button"
            variant="contained"
            color="error"
          >
            {t("LOGIN")}
          </Button>
        </Link>
      ) : (
          <div>
            <button className="border-0 bg-transparent" onClick={handleShow}>
              <div className="side-menu">
                {previewUrl ? (
                  <img
                    className="profile-image-kfc"
                    crossOrigin="anonymous"
                    src={previewUrl}
                  />
                ) : userInfo.profile_pic ? (
                  <img
                    className="profile-image-kfc"
                    crossOrigin="anonymous"
                    src={
                      userInfo.profile_pic.startsWith("https://")
                        ? userInfo.profile_pic
                        : IMAGE_URL + userInfo.profile_pic
                    }
                  />
                ) : (
                      <AccountCircleSharpIcon className="profile-link" />
                    )}
                {userInfo?.first_name}
              </div>
            </button>

            <Modal
              className="payment-modal"
              show={show}
              onHide={handleClose}
              centered
            >
              <div className="modal-design">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <Modal.Header className="justify-content-center" closeButton>
                <div className="text-center">
                  <Modal.Title className="font-bold h4">
                    {userInfo?.first_name || userInfo?.login_name}
                  </Modal.Title>
                </div>
              </Modal.Header>
              <Modal.Body className="w-100 delivery-order position-relative text-center p-0">
                <div className="detail-container mt-3">
                  <div className="d-flex align-items-center gap-10">
                    {previewUrl ? (
                      <img
                        className="profile-image-50"
                        src={previewUrl}
                        alt="profile pic"
                      />
                    ) : userInfo.profile_pic ? (
                      <img
                        className="profile-image-50"
                        src={
                          userInfo.profile_pic.startsWith("https://")
                            ? userInfo.profile_pic
                            : IMAGE_URL + userInfo.profile_pic
                        }
                        alt="profile pic"
                      />
                    ) : (
                          <span className="name-box">
                            {userInfo.first_name
                              ? userInfo?.first_name?.charAt(0).toUpperCase()
                              : "G"}
                          </span>
                        )}
                    <div className="detail-items">
                      <h5>
                        {userInfo?.first_name || userInfo?.login_name}
                      </h5>
                      <h6>{phone_number}</h6>
                      <h6>{userInfo?.email_address}</h6>
                    </div>
                  </div>
                  <Link to={`/${lang}/my-details`} className="edit-profile">
                    {t("EDIT")}
                  </Link>
                </div>
                <ul className="side-menu-links ar-side-menu-links mt-3">
                  <ul className="profile-items-main">
                    <Link to={`/${lang}/order-history`}>
                      <li className="px-4 mt-2">
                        <img
                          className="sidebar-icons"
                          src={Orderhistory}
                          alt=""
                        />
                        {t("ORDER_HISTORY")}
                      </li>
                    </Link>
                    {process.env.REACT_APP_DELIVERY_ENABLE == "true" && <Link to={`/${lang}/myaddress`}>
                      <li className="px-4 mt-2">
                        <img className="sidebar-icons" src={MyAddress} alt="" />
                        {t("MY_ADDRESS")}
                      </li>
                    </Link>}
                    <Link to={`/${lang}/your-favourites-items`}>
                      <li className="px-4 mt-2 mb-2">
                        <img className="sidebar-icons" src={AddFav} alt="" />
                        {t("MY_FAVORITES")}
                      </li>
                    </Link>
                    {/* {!socialLogin && <Link to='/change-password'>
                                        <li className='px-4 mt-2'>
                                            <i className="ri-key-fill change-password"></i>
                                            Change Password
                                        </li>
                                    </Link>} */}
                  </ul>
                  <Button
                    onClick={handlelogoutClick}
                    className="f-w-600 bg-theme font-medium"
                    variant="contained"
                    color="error"
                  >
                    {t("LOGOUT")}
                  </Button>
                </ul>
              </Modal.Body>
            </Modal>
          </div>
        )}
    </div>
  );
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    logoutUser: function (history?: any) {
      dispatch(logoutUser(history));
    }
  }
}
export default connect(null, mapDispatchToProps)(SattingScreen);



